import { NavbarButton } from "@/components/layout/Navbar/NavbarButton";
import { Icon } from "@/components/ui-deprecated";
import { useLogout } from "@/features/auth/useLogout";

const LogoutButton = () => {
    const logout = useLogout();

    const handleLogout = () => {
        logout();
    };

    return (
        <NavbarButton title={"Log out"} onClick={handleLogout}>
            <Icon icon={"sign-out-alt"} />
        </NavbarButton>
    );
};

export { LogoutButton };
